<script setup lang="ts">
// A Czech article, /cs/blog/<slug> (pages/cs-blog/index.vue).
false && /*#__PURE__*/ defineI18nRoute({ locales: ['cs'], paths: { cs: '/blog/[slug]' } })

definePageMeta({
  layout: 'blog',
  blogLocale: 'cs',
})
</script>

<template>
  <BlogArticle locale="cs" />
</template>
